import { createAction, props } from '@ngrx/store';
import { Account } from 'graphql-api/gql-api-interfaces';

export const loadBasketAccounts = createAction(
  '[Basket] Load BasketAccounts',
  props<{ basketId: string }>(),
);

export const loadBasketAccountsFailure = createAction(
  '[Basket] Load BasketAccounts Failure',
  props<{ error: string }>(),
);

export const updateActiveBasketAccounts = createAction(
  '[Basket] Update Active BasketAccounts',
);

export const setOpenedBasketAccounts = createAction(
  '[Basket] Set Opened BasketAccounts',
  props<{ basketAccounts: Account[] }>(),
);

export const setActiveBasketAccounts = createAction(
  '[Basket] Set Active BasketAccounts',
  props<{ basketAccounts: Account[] }>(),
);

/**
 * Compare basket accounts and accounts selection action
 */
export const compareBasketAndAccountsSelection = createAction(
  '[Basket] Compare Basket and Accounts Selection',
  props<{ basketId: string; selectedAccounts: Account[] }>(),
);

/**
 * Compare basket accounts and accounts selection failure action
 */
export const compareBasketAndAccountsSelectionFailure = createAction(
  '[Basket] Compare Basket and Accounts Selection Failure',
  props<{ error: string }>(),
);

export const setBasketToAccount = createAction(
  '[Basket] Set Active Basket To Account',
  props<{ basketId: string; accountId: string }>(),
);
